// @flow
import React, { Component } from 'react';
import classnames from 'classnames';

import NavLink from 'src/components/NavLink/NavLink';
import {
  Button,
  Text,
  Section,
  PageBlock,
  Highlight
} from 'seek-style-guide/react';
import SignInRegisterLink, {
  LOGIN_MODES
} from 'src/components/SignInRegisterLink/SignInRegisterLink';
import { connect } from 'react-redux';

import styles from './SmokeBanner.less';
import bannerStyles from '../HomePageBanner.less';

const profilePagePathname = '/profile/me';

type Props = {
  authenticated: boolean
};

const mapStateToProps = ({ user }) => ({
  authenticated: user.authenticated
});

class SmokeBanner extends Component<*> {
  props: Props;

  render() {
    const { authenticated } = this.props;

    const profileLinkProps = authenticated
      ? {
          location: profilePagePathname,
          component: NavLink
        }
      : {
          mode: LOGIN_MODES.SIGN_IN,
          returnLocation: { pathname: profilePagePathname },
          component: SignInRegisterLink
        };

    return (
      <PageBlock className={bannerStyles.root}>
        <div className={styles.root}>
          <Section header className={styles.candidate}>
            <div>
              <Text subheading strong className={styles.text}>
                <Highlight
                  className={classnames(styles.highlight, styles.teal)}
                >
                  Be seen with a
                </Highlight>
                <br />
                <Highlight
                  className={classnames(styles.highlight, styles.teal)}
                >
                  SEEK Profile
                </Highlight>
              </Text>
              <Button
                className={styles.profileButton}
                color="white"
                ghost
                analytics="smoke-banner-update-profile-clicked"
                {...profileLinkProps}
              >
                Update Profile
              </Button>
            </div>
          </Section>
          <Section header className={styles.hirer}>
            <div>
              <Text strong subheading className={styles.text}>
                <Highlight
                  className={classnames(styles.highlight, styles.blue)}
                >
                  Hiring? Your job ad seen
                </Highlight>
                <br />
                <Highlight
                  className={classnames(styles.highlight, styles.blue)}
                >
                  by all the right&nbsp;people
                </Highlight>
              </Text>
              <Button
                component={NavLink}
                analytics="smoke-banner-find-out-more-clicked"
                color="white"
                location="https://insightsresources.seek.com.au/page/job-ad-support"
                ghost
              >
                Find out more
              </Button>
              <Button
                component={NavLink}
                color="transparent"
                className={styles.employer}
                location="https://talent.seek.com.au/"
                analytics="smoke-banner-employer-site-clicked"
              >
                Employer Site
              </Button>
            </div>
          </Section>
        </div>
      </PageBlock>
    );
  }
}

export default connect(mapStateToProps)(SmokeBanner);
